module.exports = __webpack_public_path__ + "img/vtkjs.88cb7927.svg";